import { SAMPLE_QUOTE } from './sampleQuote';

export const FINALIZE_PASSENGER_PROFILES_SAMPLE = {
  quote: SAMPLE_QUOTE,
  profileUrl: { url: 'https://gotrustjet.com/passengers/sample?token=abc' },
  flights: [
    { departure_airport: 'TEB', arrival_airport: 'MIA', departure_date: '2025-10-24T10:00:00Z' },
    { departure_airport: 'MIA', arrival_airport: 'TEB', departure_date: '2025-10-28T14:00:00Z' },
  ],
};
